var React = require('react');

function FatArrowUpDark (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_11827","data-name":"Path 11827","d":"M9.037,18.047l0-7.246H4.508L11.3,4.012,18.088,10.8H13.563v7.246Z","transform":"translate(-4.508 -4.012)","fill":"#0d3e4b"}));
}

FatArrowUpDark.defaultProps = {"width":"13.58","height":"14.035","viewBox":"0 0 13.58 14.035"};

module.exports = FatArrowUpDark;

FatArrowUpDark.default = FatArrowUpDark;
